import { render, staticRenderFns } from "./form-password-reset.vue?vue&type=template&id=3e9cdc19&"
import script from "./form-password-reset.vue?vue&type=script&lang=js&"
export * from "./form-password-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports